import classNames from "classnames";
import React from "react";
import { ContactDataResponse } from "../../../integrations/allkort/graphql/interface/Customer";
import { MailBoxIcon } from "../../svgs/ExpressonSVGs";

/**
 * This component is used in both Smartcard and Creditcard sections in profile settings to render the letter delivery method option for statements and invoices respectively. It receives the card type as a prop to determine which section it belongs to and renders the appropriate text for that card type. The actual functionality for saving the chosen delivery method is yet to be implemented, so currently it serves as a placeholder for the UI elements related to letter delivery settings.
 * 
 * @param cardType - A string indicating the type of card ("P" for SmartCard or "K" for CreditCard) to determine which section's letter delivery option to render.
 * @returns A React component that displays the letter delivery option for the specified card type.
 */
type LetterDeliveryCardType = "P" | "K"

type LetterDeliveryProps = {
    cardType: LetterDeliveryCardType
    isActiveMethod: boolean
    customerContactData: ContactDataResponse
    onSelect?: () => void
}

const CardLetterDelivery: React.FC<LetterDeliveryProps> = ({ cardType, isActiveMethod, customerContactData, onSelect }) => {
    const [clicked, setClicked] = React.useState(false);

    const handleClick = () => {
        if (!isActiveMethod && onSelect) {
            onSelect();
            return;
        }
        setClicked(true);
        setTimeout(() => {
            setClicked(false);
        }, 3000);
    }
    return (
        <>
            <div
                className={classNames(
                    "method",
                    'letter-delivery-method-component',
                    { "active": isActiveMethod, }
                )}
                onClick={handleClick}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(); } }}
                tabIndex={0}
            >
                <div
                    className="method-header"
                >
                    <span
                        className={classNames(
                            "method-icon",
                            { 'clicked': clicked }
                        )}
                    >{/* Empty: CSS will fill in the visuals. */}</span>

                    <div className="method-content">
                        <span className="method-name">Via brev</span>
                        <p>{cardType === "P" ? "Kontobeskedet" : "Fakturan"} skickas till din folkbokföringsadress.</p>
                    </div>

                    <MailBoxIcon width={45} height={45} />
                </div>
            </div>


        </>
    )
}

export default CardLetterDelivery;